import { Button } from "@/components/ui/button";
import { buildWhatsAppUrl } from "@/lib/whatsapp";
import { MessageCircle } from "lucide-react";
import { cn } from "@/lib/utils";

export interface WhatsAppButtonProps {
  phone: string | null | undefined;
  message: string;
  className?: string;
  children?: React.ReactNode;
  onClick?: () => void;
}

export default function WhatsAppButton({
  phone,
  message,
  className,
  children = "Falar no WhatsApp",
  onClick,
}: WhatsAppButtonProps) {
  if (!phone) return null;

  const href = buildWhatsAppUrl(phone, message);

  return (
    <Button asChild className={cn(className)}>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
      >
        <MessageCircle className="size-4" />
        {children}
      </a>
    </Button>
  );
}
